// extracted by mini-css-extract-plugin
export var alignBaseline = "_6-9";
export var alignCenter = "_6-5";
export var alignFlexEnd = "_6-7";
export var alignFlexStart = "_6-6";
export var alignSelfBaseline = "_6-e";
export var alignSelfCenter = "_6-a";
export var alignSelfFlexEnd = "_6-c";
export var alignSelfFlexStart = "_6-b";
export var alignSelfStretch = "_6-d";
export var alignStretch = "_6-8";
export var column = "_6-2";
export var columnReverse = "_6-4";
export var flex = "_6-0";
export var justifyCenter = "_6-f";
export var justifyFlexEnd = "_6-h";
export var justifyFlexStart = "_6-g";
export var justifySpaceAround = "_6-j";
export var justifySpaceBetween = "_6-i";
export var justifySpaceEvenly = "_6-k";
export var row = "_6-1";
export var rowReverse = "_6-3";
export var wrapNowrap = "_6-m";
export var wrapWrap = "_6-l";
export var wrapWrapReverse = "_6-n";